export default __webpack_public_path__ + "static/media/RedeemDarkMode.ec999c24.svg";